/* eslint-disable @typescript-eslint/no-empty-function */
import { NgClass } from '@angular/common';
import {
  Component,
  input,
  computed,
  forwardRef,
  booleanAttribute,
  linkedSignal,
  model
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-radio-item',
  standalone: true,
  imports: [NgClass, FormsModule],
  templateUrl: './radio-item.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioItemComponent),
      multi: true
    }
  ]
})
export class RadioItemComponent implements ControlValueAccessor {
  key = input<string>();
  label = input<string>();
  description = input<string>();
  size = input<'sm' | 'md' | 'lg'>('md');
  disabled = input(false, { transform: booleanAttribute });
  variant = input<'check' | 'radio'>('radio');
  groupName = input<string>('radio-group');

  optionValue = input<string | number>();

  selectedValue = model<string | number>();

  isDisabled = linkedSignal(() => this.disabled());

  id = computed(
    () =>
      this.key() ||
      this.label() ||
      'radio-' + Math.random().toString(36).substring(2)
  );

  private onChange: (value: string | number) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: string | number): void {
    this.selectedValue.set(value);
  }

  registerOnChange(fn: (value: string | number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled.set(isDisabled);
  }

  handleChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.checked) {
      const newValue =
        this.optionValue() !== undefined ? this.optionValue() : target.value;
      this.selectedValue.set(newValue);
      this.onChange(newValue);
      this.onTouched();
    }
  }
}
